import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { enableMapSet } from 'immer';

type setNewFlatItemProps = {
  taskId: string;
  isCheckAllFilterChecked: boolean;
};

type FlatListTasksStore = {
  flatTaskListCheckMap: Map<string, { checked: boolean }>;
  setNewFlatItem: (props: setNewFlatItemProps) => void;
  onCheck: (taskId: string) => void;
  onCheckAll: () => void;
};

enableMapSet();

export const useFlatTasksListStore = create(
  immer<FlatListTasksStore>((set) => {
    return {
      flatTaskListCheckMap: new Map<string, { checked: boolean }>([]),
      setNewFlatItem: ({ taskId, isCheckAllFilterChecked }) => {
        set((state) => {
          state.flatTaskListCheckMap.set(taskId, { checked: isCheckAllFilterChecked || false });
        });
      },
      onCheck: (taskId) => {
        set((state) => {
          const task = state.flatTaskListCheckMap.get(taskId);
          if (task) {
            state.flatTaskListCheckMap.set(taskId, { checked: !task.checked });
          }
        });
      },
      onCheckAll: () => {
        set((state) => {
          state.flatTaskListCheckMap.clear();
        });
      },
    };
  }),
);
